__turbopack_context__.v({
  "filters": "SuggestionsFilter-module__pC6suW__filters",
  "title": "SuggestionsFilter-module__pC6suW__title",
});
